import React, { useCallback, useState } from 'react';
import TrueImpactTextfield from 'shared/design-system/components/TrueImpactTextfield';
import styled from 'styled-components';
import QuestionsModal from '../../../Guidance/QuestionsModal';
import TrueImpactIconButton from 'shared/design-system/components/TrueImpactIconButton';
import { useReportBuilderQuestions } from '../../../Guidance/hook';
import { FeedbackSectionId } from 'donor/portal/pages/FeedbackDashboard/Feedback/utils';
import { faSearch } from '@fortawesome/pro-light-svg-icons';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { AllNpoReportQuestions } from '../../../Guidance/api';

interface SelectQuestionProps {
  forceAllowQuestionIds: number[];
  selectQuestionId: number | undefined;
  disableOtherSections: boolean;
  defaultExpandedSectionId?: FeedbackSectionId;
  handleChange: (
    question: AllNpoReportQuestions['allNpoReportQuestions'][number],
  ) => unknown;
}

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACERS.tiny};
  margin-bottom: ${SPACERS.tiny};
  .search-icon.MuiIconButton-root {
    background-color: ${COLORS.ctaPrimaryBackground};
    transition: background-color 0.3s ease-in-out;
    &:hover {
      background-color: ${COLORS.grayLight};
    }
  }
`;

const SelectQuestion: React.FC<SelectQuestionProps> = ({
  forceAllowQuestionIds,
  selectQuestionId,
  disableOtherSections,
  defaultExpandedSectionId,
  handleChange,
}) => {
  const { questions } = useReportBuilderQuestions();
  const [open, setOpen] = useState<boolean>(false);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, [setOpen]);
  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  return (
    <>
      <StyledDiv>
        <TrueImpactTextfield
          placeholder="Question Id"
          value={selectQuestionId}
          disabled={true}
          title="Use the search icon to find the question id"
          className="question-id"
        />
        <TrueImpactIconButton
          icon={faSearch}
          onClick={handleOpen}
          className="search-icon"
        />
      </StyledDiv>
      <QuestionsModal
        open={open}
        forceAllowQuestionIds={forceAllowQuestionIds}
        disableOtherSections={disableOtherSections}
        defaultExpandedSectionId={defaultExpandedSectionId}
        questions={questions}
        handleClose={handleClose}
        handleAddQuestion={q => {
          handleChange(q);
          handleClose();
        }}
      />
    </>
  );
};

export default SelectQuestion;
